import React, { FC } from 'react';
import { GxButton, GxIcon } from '@garpix/garpix-web-components-react';
import ModalLayout from '../../../../components/ModalLayout';
import styles from './index.module.scss';
import { IModalExtendDeposit } from './types';
import { CertificateIcon } from '../../../../assets';

const ModalExtendDeposit: FC<IModalExtendDeposit> = ({ flag, onRequestClose, onSave, depositName }) => {
  return (
    <ModalLayout
      flag={flag}
      onClose={() => {
        onRequestClose();
      }}
    >
      <div className={styles.header}>
        <div className={styles.header__container}>
          <GxIcon className={styles.header__icon} src={CertificateIcon}/>
          <h2 className={styles.header__title}>Продление депозита</h2>
        </div>
        <div className={styles.header__deposit}>
          Депозит:{' '}
            <span >{depositName}</span>
        </div>
      </div>
      <div className={styles.main}>
        <h2 className={styles.main__title}>
          Вы уверены, что хотите продлить выбранный депозит на 60 дней?
        </h2>
      </div>
      <div className={styles.footer}>
        <div className={styles.footer__container}>
          <GxButton
            className={styles.btn__close}
            onClick={onRequestClose}
          >
            Отмена
          </GxButton>
          <GxButton
            className={styles.btn__save}
            type="submit"
            onClick={onSave}
          >
            Подтвердить
          </GxButton>
        </div>
      </div>
    </ModalLayout>
  );
};

export default ModalExtendDeposit;